import { type GriffelStyle, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

const MAX_WIDTH = px(1920);

export const getLayoutMaxWidth = (keepPadding: boolean): GriffelStyle => ({
    width: '100%',
    maxWidth: keepPadding
        ? `min(100%, ${MAX_WIDTH})`
        : `min(100%, calc(${MAX_WIDTH} - (${tokens.spacingHorizontalXXL} * 2)))`,
    marginInline: 'auto',
});
